import moment from 'moment';

const formatDate = (date: string, dateFormat: string): string => {
  const targetIndex = date.lastIndexOf(':');
  const sliced = date.slice(0, targetIndex);
  return moment(sliced).format(dateFormat);
};

export default formatDate;
